// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"627":"72520b44","714":"48d23645","858":"3235d456","925":"83634cc4","934":"ed4d264c"}[chunkId] + ".chunk.css";
};